
<template>
    <div>
    </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { getLongUrlByShortID, updateClickByShortID } from '../api/redirect.js'

export default {
  name: 'RedirectTemplate',
  data: function () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  },
  created: function () {
    this.upsertLog()
    this.redirect()
  },
  methods:
    {
      upsertLog: function () {
        updateClickByShortID(this.$route.params.id)
      },
      redirect: function () {      
        let urlRes = getLongUrlByShortID(this.$route.params.id)
        urlRes.then((success) => {
          if (success !== '' && success !== null) {
            document.location.href = success
          } else {
            // 轉址錯誤
          }
        }, (fail) => {
          console.log(fail)
        })
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
